import { render, staticRenderFns } from "./RecommendationsFooter.vue?vue&type=template&id=72877758&scoped=true"
import script from "./RecommendationsFooter.vue?vue&type=script&lang=js"
export * from "./RecommendationsFooter.vue?vue&type=script&lang=js"
import style0 from "./RecommendationsFooter.vue?vue&type=style&index=0&id=72877758&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72877758",
  null
  
)

export default component.exports